import { Eyebrow } from "cai-fusion";
import SymphonyChatInput from "../components/symphonyChatInput";
import SymphonyChat from "../components/symphonyChat";
import LeaveSharedChat from "../components/Chat/LeaveSharedChat";

// Contexts
import { useAccess } from "../contexts/AccessContext";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";

const SymphonyChatPage = ({
    lockInput,
    editingMessageId,
    setEditingMessageId,
}) => {

    const { canSendMessage } = useAccess();
    const { show } = useTransientVisibility();

    return (
        <>
            <Eyebrow>Beginning of chat</Eyebrow>
            <SymphonyChat
                lockInput = {lockInput}
                editingMessageId = {editingMessageId}
                setEditingMessageId = {setEditingMessageId}
            />
            {canSendMessage ? (
                <SymphonyChatInput />
            ) : (
                <LeaveSharedChat onLeaveChat={() => {show("LeaveSharedChatModal")}} /> 
            )}
        </>
    );
};


export default SymphonyChatPage;
